import { ContactsScreen } from "@src/features/contacts/screens/ContactsScreen";

export default function ActivityNotificationPage() {
  return <ContactsScreen title="Contacts" category="activity" />;
}
